import React, { useState } from "react";

const PreferenceNumber = ({ isOpen, onClose, onSave }) => {
    const [autoGenerate, setAutoGenerate] = useState(true);
    const [prefix, setPrefix] = useState("INV-");
    const [nextNumber, setNextNumber] = useState("000002");

    if (!isOpen) return null;

    const handleSave = () => {
        const settings = {
            autoGenerate,
            prefix,
            nextNumber: autoGenerate ? nextNumber : null
        };
        if (onSave) onSave(settings);
        if (onClose) onClose();
    };

    const handleClose = () => {
        if (onClose) onClose();
    };

    return (
        <div className="absolute flex h-full w-full z-50 rounded-lg flex-col items-center pb-28 px-56 bg-[#E0E0E0E0]/80  backdrop-blur-sm rounded-3xl">
            <div className="bg-white shadow-lg rounded-lg w-[800px]">
                <h1 className="font-bold text-[18px] p-4 border-b text-center bg-tertiary rounded-t-lg">
                    Configure Preference Number
                </h1>
                <div className="p-6 space-y-4">
                    {/* <p className="text-sm text-gray-600">
                        Your invoice numbers are set on auto-generate mode to save your time. Are you sure about changing this setting?
                    </p> */}
                    <div className="flex flex-col gap-3">
                        {/* <label className="flex items-center gap-2">
                            <input 
                                type="radio" 
                                checked={autoGenerate} 
                                onChange={() => setAutoGenerate(true)}

                            />
                            Continue auto-generating invoice numbers
                        </label> */}
                        {autoGenerate && (
                            <div className="flex gap-2 pl-6">
                                <label >
                                    Prefix
                                    <input
                                        type="text"
                                        value={prefix}
                                        onChange={(e) => setPrefix(e.target.value)}
                                        className="border p-2 rounded w-25"
                                        placeholder="prefix"
                                    />
                                </label>
                                <label>
                                    ORG Alias
                                    <input
                                        type="text"
                                        value={prefix}
                                        onChange={(e) => setPrefix(e.target.value)}
                                        className="border p-2 rounded w-25"
                                        placeholder="org alias"
                                    />
                                </label>

                                <label >
                                    Financial Year
                                    <input
                                        type="text"
                                        value={prefix}
                                        onChange={(e) => setPrefix(e.target.value)}
                                        className="border p-2 rounded w-25"
                                        placeholder="Current Financial Year"
                                    />
                                </label>

                                <label >
                                    Starting Number
                                    <input
                                        type="text"
                                        value={nextNumber}
                                        onChange={(e) => setNextNumber(e.target.value)}
                                        className="border p-2 rounded w-25"
                                        placeholder="serial number"
                                    />
                                </label>


                            </div>
                        )}
                        {/* <label className="flex items-center gap-2">
                            <input 
                                type="radio" 
                                checked={!autoGenerate} 
                                onChange={() => setAutoGenerate(false)}
                            />
                            Enter invoice numbers manually
                        </label> */}
                    </div>
                    <div className="flex justify-end gap-2 pt-4">
                        <button
                            className="bg-primary text-secondary  text-[12px] rounded-3xl px-4 py-2 rounded hover:bg-[#4141FF]"
                            onClick={handleSave}
                        >
                            Save
                        </button>
                        <button
                            className="bg-[#979c97] text-secondary  text-[12px] rounded-3xl px-4 py-2 rounded hover:bg-[#4141FF]"
                            onClick={handleClose}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PreferenceNumber;
